const e = {
  red: 16711680,
  green: 65280,
  blue: 255,
  yellow: 16776960,
  purple: 16711935,
  cyan: 65535,
  white: 16777215,
  black: 0,
  gray: 8421504,
  orange: 16753920,
  pink: 16761035,
  lime: 65280,
  gold: 16766720
}, s = /^-?\d+(\.\d+)?(\s+-?\d+(\.\d+)?)+$/, o = {
  parse(r) {
    return this.isVector(r) ? this.parseVector(r) : this.isHexColor(r) ? this.parseHexColor(r) : this.isNamedColor(r) ? this.parseNamedColor(r) : this.isBoolean(r) ? this.parseBoolean(r) : this.isNumber(r) ? this.parseNumber(r) : r;
  },
  isVector(r) {
    return s.test(r);
  },
  parseVector(r) {
    const t = r.split(/\s+/).map(Number);
    return t.length === 2 ? { x: t[0], y: t[1] } : t.length === 3 ? { x: t[0], y: t[1], z: t[2] } : t.length === 4 ? { x: t[0], y: t[1], z: t[2], w: t[3] } : t;
  },
  isHexColor(r) {
    return r.startsWith("0x") ? /^0x[0-9a-fA-F]+$/.test(r) : r.startsWith("#") ? /^#[0-9a-fA-F]+$/.test(r) : !1;
  },
  parseHexColor(r) {
    return r.startsWith("0x") ? parseInt(r, 16) : parseInt(r.slice(1), 16);
  },
  isNamedColor(r) {
    return Object.prototype.hasOwnProperty.call(e, r.toLowerCase());
  },
  parseNamedColor(r) {
    return e[r.toLowerCase()];
  },
  isBoolean(r) {
    return r === "true" || r === "false";
  },
  parseBoolean(r) {
    return r === "true";
  },
  isNumber(r) {
    return !isNaN(parseFloat(r));
  },
  parseNumber(r) {
    return parseFloat(r);
  }
};
export {
  o as XMLValueParser
};
//# sourceMappingURL=values.js.map
